import React, { useState } from "react";

const MenuButton = ({ onClick, isOpen }) => {
  return (
    <button
      type="button"
      aria-controls="menu"
      aria-label={isOpen ? 'Cerrar menú' : 'Abrir menú'}
      aria-expanded={isOpen ? 'true' : 'false'}
      onClick={onClick}
    >
      <svg
        className="menuOpen"
        aria-hidden="true"
        width="40"
        height="28"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g stroke="#000" strokeWidth="3" fill="none" fillRule="evenodd">
          <path d="M.339 2.301h28.475M.339 10.301h23.729M.339 18.301h39.322M.339 26.301h28.475" />
        </g>
      </svg>
      <svg
        aria-hidden="true"
        width="30"
        height="27"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g stroke="#000" strokeWidth="3" fill="none" fillRule="evenodd">
          <path d="m3.773 25 23.12-23M26.893 25 3.773 2" />
        </g>
      </svg>
      <svg
        aria-hidden="true"
        width="60"
        height="28"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g stroke="#000" strokeWidth="3" fill="none" fillRule="evenodd">
          <path d="M30.339 2.301h28.475M20.339 10.301h23.729M.339 18.301h39.322M30.339 26.301h28.475" />
        </g>
      </svg>
    </button>
  );
};

export default MenuButton;
